import { makeStyles } from "@mui/styles";


  const useStyles = makeStyles({
    buttonColor1:{
      'backgroundColor': '#ffffff',
    },
    buttonColor2:{
      'backgroundColor': '#f0ffff',

    },
    buttonColor3:{
      'backgroundColor': '#ff1fff',

    },
    buttonColor4:{
      'backgroundColor': '#fff000',
    },

  });
  
  const useStyles2 = makeStyles({
    
    folilRuka:{
      width:'100%',
      padding: '0px 0px 0px 0px',

    },
    buttonNav:{
      border: '1px solid #000',
    }
  });

  const useStyles3 = makeStyles({
    folil: {
        width: "100%",
        'backgroundColor': "#151515",
        'margin-left': 0,
        'margin-right':0,
        'padding': '0 0 0 0',
        'padding-right': 0 
    }  

});



export { useStyles, useStyles2, useStyles3 }


